module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.vocab) ? _c('article', [_vm._v("loading...")]) : _c('article', {
    on: {
      "click": _vm.next
    }
  }, [(_vm.stage === 'showQuestion') ? _c('section', {
    staticClass: "question",
    on: {
      "click": function($event) {
        _vm.stage = 'showAnswer'
      }
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.vocab.lang1) + "\n\t")]) : (_vm.stage === 'showAnswer') ? _c('section', {
    staticClass: "answer",
    on: {
      "click": function($event) {
        _vm.stage = 'showRating'
      }
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.vocab.lang2) + "\n\t")]) : [_c('button', {
    staticClass: "rating wrong",
    on: {
      "click": function($event) {
        _vm.answer(false)
      }
    }
  }, [_c('div', [_vm._v(": (")])]), _vm._v(" "), _c('button', {
    staticClass: "rating right",
    attrs: {
      "autofocus": ""
    },
    on: {
      "click": function($event) {
        _vm.answer(true)
      }
    }
  }, [_c('div', [_vm._v(": )")])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-782846e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VocabCardQuestion.vue
// module id = 97
// module chunks = 2